<h2 mat-dialog-title class="modal-header">
  <span class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">add_link</mat-icon>
  </span>
  <span class="modal-header-titles">
    <span class="modal-title">Vincular itens avulsos</span>
    <span class="apa-subtitulo">O Pedido de Compra só aceita produtos do cadastro. Vincule ou cadastre cada item para avançar.</span>
  </span>
  <span class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" matTooltip="Fechar"
      [disabled]="isConfirmando" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </span>
</h2>

<mat-dialog-content class="modal-content">
  <div class="apa-lista">
    @for (linha of linhas; track linha.item.idCompraItem) {
      <div class="apa-item" [class.apa-item--removido]="linha.isRemover" [class.apa-item--divergente]="!!divergencia(linha)">
        <div class="apa-item-cabecalho">
          <span class="apa-item-icone">
            <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
          </span>
          <div class="apa-item-textos">
            <span class="apa-item-nome">{{ linha.item.nome }}</span>
            <span class="apa-item-meta">
              {{ formatarQuantidade(linha.item.quantidade) }} {{ linha.item.unidade || '' }}@if (linha.item.observacao) { · {{ linha.item.observacao }} }
            </span>
          </div>
          @if (linha.isRemover) {
            <span class="status-badge badge-cinza">
              <mat-icon class="material-symbols-outlined">remove_shopping_cart</mat-icon>
              Será removido
            </span>
          } @else if (divergencia(linha)) {
            <span class="status-badge badge-amarelo">
              <mat-icon class="material-symbols-outlined">warning</mat-icon>
              Produto repetido
            </span>
          } @else if (linha.produto) {
            <span class="status-badge badge-verde">
              <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
              Vinculado
            </span>
          } @else {
            <span class="status-badge badge-cinza">
              <mat-icon class="material-symbols-outlined">schedule</mat-icon>
              Pendente
            </span>
          }
        </div>

        @if (linha.isRemover) {
          <div class="apa-painel apa-painel--linha">
            <span class="apa-texto-secundario">Este item avulso será removido da compra ao confirmar.</span>
            <button mat-button type="button" class="btn-section" [disabled]="isConfirmando" (click)="desfazerRemocao(linha)">
              <mat-icon class="material-symbols-outlined">undo</mat-icon>
              Desfazer
            </button>
          </div>
        } @else {
          <!-- Produto escolhido -->
          @if (linha.produto && !linha.isBuscaAberta) {
            <div class="apa-painel apa-painel--linha">
              <span class="apa-produto-icone">
                <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
              </span>
              <div class="apa-item-textos">
                <span class="apa-rotulo">Produto do cadastro</span>
                <span class="apa-produto-nome">{{ linha.produto.nome }}</span>
                @if (metaProduto(linha.produto)) {
                  <span class="apa-item-meta">{{ metaProduto(linha.produto) }}</span>
                }
              </div>
              <button mat-button type="button" class="btn-section" [disabled]="isConfirmando" (click)="trocarProduto(linha)">
                <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
                Trocar
              </button>
            </div>

            @if (divergencia(linha); as aviso) {
              <div class="apa-divergencia">
                <mat-icon class="material-symbols-outlined">warning</mat-icon>
                <span class="apa-divergencia-texto">{{ aviso }}</span>
                <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isConfirmando" (click)="removerItem(linha)">
                  <mat-icon class="material-symbols-outlined">remove_shopping_cart</mat-icon>
                  Remover item
                </button>
              </div>
            }
          }

          <!-- Busca no cadastro: aberta direto no item pendente; no vinculado, só ao trocar -->
          @if (!linha.produto || linha.isBuscaAberta) {
            <div class="apa-busca">
              <mat-form-field appearance="outline" class="apa-busca-campo" subscriptSizing="dynamic">
                <mat-label>Buscar produto no cadastro</mat-label>
                <mat-icon matIconPrefix class="material-symbols-outlined">search</mat-icon>
                <input matInput type="text" placeholder="Nome ou SKU do produto…"
                  [ngModel]="linha.termoBusca"
                  (ngModelChange)="alterarTermoBusca(linha, $event)"
                  [disabled]="isConfirmando"
                  [matAutocomplete]="autoProduto">
                @if (linha.isPesquisando) {
                  <mat-progress-spinner matSuffix mode="indeterminate" diameter="18"></mat-progress-spinner>
                }
                <mat-autocomplete #autoProduto="matAutocomplete" [displayWith]="exibirVazio"
                  (optionSelected)="escolherProduto(linha, $event.option.value)">
                  @for (p of linha.resultados; track p.idProduto) {
                    <mat-option [value]="p">
                      <div class="apa-opcao">
                        <span class="apa-opcao-nome">{{ p.nome }}</span>
                        @if (metaProduto(p)) {
                          <span class="apa-opcao-meta">{{ metaProduto(p) }}</span>
                        }
                      </div>
                    </mat-option>
                  }
                  @if (!linha.isPesquisando && linha.resultados.length === 0 && linha.termoBusca.trim().length > 1) {
                    <mat-option disabled>Nenhum produto encontrado.</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              @if (linha.produto) {
                <button mat-stroked-button type="button" class="btn-secondary apa-busca-botao" (click)="fecharBusca(linha)">Cancelar</button>
              } @else {
                <span class="apa-busca-acao" [matTooltip]="podeCadastrar ? tooltipCadastroCompleto : tooltipSemPermissao">
                  <button mat-stroked-button type="button" class="btn-secondary apa-busca-botao"
                    [disabled]="!podeCadastrar || isConfirmando" (click)="abrirCadastroCompleto(linha)">
                    <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                    Cadastrar produto
                  </button>
                </span>
              }
            </div>
          }
        }
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <span class="apa-progresso">
    @if (!isCarregando) {
      <strong>{{ totalResolvidos }}</strong> de {{ linhas.length }} {{ linhas.length === 1 ? 'item resolvido' : 'itens resolvidos' }}
    }
  </span>
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isConfirmando" (click)="cancelar()">Cancelar</button>
  <span [matTooltip]="motivoConfirmarDesabilitado">
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isConfirmando"
      [disabled]="!!motivoConfirmarDesabilitado || isCarregando || isConfirmando"
      [attr.aria-label]="isConfirmando ? 'Confirmando e movendo' : 'Confirmar e mover'" (click)="confirmar()">
      <mat-icon class="material-symbols-outlined">arrow_forward</mat-icon>
      Confirmar e mover
      @if (isConfirmando) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
  </span>
</mat-dialog-actions>
